export const getManageMenuSelectedKey = ({pathname, hash}) => {
    if(pathname.endsWith('/manage/configurable-entities') && ['#metadata-entities', '#standard-metadata-entities', '#metadata-entity-fields', '#metadata-entity-imports'].includes(hash)) {
        return 'custom-metadata';
    }

    if (['/manage/custom-meta-fields', '/manage/custom-metadata-entities', '/manage/custom-metadata'].some(route => pathname.endsWith(route))) return 'custom-metadata';

    const pathSegments = pathname.split('/').filter(Boolean);
    const manageIndex = pathSegments.lastIndexOf('manage');

    return manageIndex === -1 ?
        pathSegments[pathSegments.length - 1] :
        pathSegments[manageIndex + 1];
}
